import React from 'react';

const ExtensionLabel = ({className, label, children, style}) => {
	return (
		<span className={`extension-label ml-s${className ? ' ' + className : ''}`} style={style}>{label || children}</span>
   );
}

export default ExtensionLabel;